<div class="row" style="margin-left: -24px;" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="row" style="margin-left: -24px;" *ngIf="serverError === null">

  <div class="col-xl-2 col-3 element-table-wrapper">
  <table class="table table-hover element-table mb-5">
    <tbody>
    <tr class="element-header"><th>Standard Questions</th></tr>
    <tr class="element-row"
        *ngFor="let elementType of CapitanDocumentElementTypes">
      <td (click)="toggleSelectedElementType(elementType)">
        {{ getDocumentElementTypeDisplay(elementType) }}
        <div class="choose-section-for-element"
             *ngIf="selectedElementType === elementType"
             (click)="$event.stopPropagation()">
          <span class="text-muted py-1">Add to section:</span>
          <div class="btn-group-vertical">
            <div *ngFor="let section of sectionsForElementType(elementType)" [ngbTooltip]="sectionContainsElementType(elementType, section) ? 'Already added' : null">
              <button (click)="addElementTypeToSection(elementType, section)"
                      type="button" class="btn btn-outline-primary btn-sm"
                      [disabled]="sectionContainsElementType(elementType, section)"
                      [class.disabled]="sectionContainsElementType(elementType, section)">
                {{ getSectionDisplayName(section) }}
              </button>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <tr class="element-header"><th>Custom Customer Fields</th></tr>
    <tr class="element-row inactive-row" style="cursor: default"
        *ngIf="customCustomerFieldsLoading">
      <td class="text-muted">Loading...</td>
    </tr>
    <tr class="element-row inactive-row" style="cursor: default"
        *ngIf="!customCustomerFieldsLoading && (customCustomerFields.length === 0)">
      <td class="text-muted">No fields configured</td>
    </tr>
    <ng-container *ngIf="!customCustomerFieldsLoading">
      <tr class="element-row"
          *ngFor="let field of customCustomerFields">
        <td (click)="toggleSelectedElementTypeCustomCustomerField(field)">
          {{ field.name }}
          <div class="choose-section-for-element"
               *ngIf="(selectedElementType === DocumentElementType.customCustomerField) && (selectedElementTypeFieldId === field.id)"
               (click)="$event.stopPropagation()">
            <span class="text-muted py-1">Add to section:</span>
            <div class="btn-group-vertical">
              <div *ngFor="let section of participantInformationSections()" [ngbTooltip]="sectionContainsCustomField(field, section) ? 'Already added' : null">
                <button (click)="addElementTypeCustomCustomerFieldToSection(field, section)"
                        type="button" class="btn btn-outline-primary btn-sm"
                        [disabled]="sectionContainsCustomField(field, section)"
                        [class.disabled]="sectionContainsCustomField(field, section)">
                  {{ getSectionDisplayName(section) }}
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>

    <tr class="element-header"><th>Custom Questions</th></tr>
    <tr class="element-row"
        *ngFor="let elementType of CustomQuestionDocumentElementTypes">
      <td (click)="toggleSelectedElementType(elementType)">
        {{ getDocumentElementTypeDisplay(elementType) }}
        <div class="choose-section-for-element"
             *ngIf="selectedElementType === elementType"
             (click)="$event.stopPropagation()">
          <span class="text-muted py-1">Add to section:</span>
          <div class="btn-group-vertical">
            <button *ngFor="let section of nonPageBreakSections()"
                    (click)="addElementTypeToSection(elementType, section)"
                    type="button" class="btn btn-outline-primary btn-sm">
              {{ getSectionDisplayName(section) }}
            </button>
          </div>
        </div>
      </td>
    </tr>

    <tr class="element-header"><th>Policies</th></tr>
    <tr class="element-row inactive-row" style="cursor: default"
        *ngIf="documentPoliciesLoading">
      <td class="text-muted">Loading...</td>
    </tr>
    <tr class="element-row inactive-row" style="cursor: default"
        *ngIf="!documentPoliciesLoading && (getActivePolicies().length === 0)">
      <td class="text-muted">No active policies</td>
    </tr>
    <ng-container *ngIf="!documentPoliciesLoading">
      <tr class="element-row"
          *ngFor="let policy of getActivePolicies()">
        <td (click)="toggleSelectedElementTypePolicy(policy)">
          {{ policy.name }}
          <div class="choose-section-for-element"
               *ngIf="(selectedElementType === DocumentElementType.policy) && (selectedElementTypePolicyId === policy.id)"
               (click)="$event.stopPropagation()">
            <span class="text-muted py-1">Add to section:</span>
            <div class="btn-group-vertical">
              <button *ngFor="let section of nonPageBreakSections()"
                      (click)="addElementTypePolicyToSection(policy, section)"
                      type="button" class="btn btn-outline-primary btn-sm">
                {{ getSectionDisplayName(section) }}
              </button>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>

    <tr class="element-header"><th>Content</th></tr>
    <tr class="element-row"
        *ngFor="let elementType of ContentDocumentElementTypes">
      <td (click)="toggleSelectedElementType(elementType)">
        {{ getDocumentElementTypeDisplay(elementType) }}
        <div class="choose-section-for-element"
             *ngIf="selectedElementType === elementType"
             (click)="$event.stopPropagation()">
          <span class="text-muted py-1">Add to section:</span>
          <div class="btn-group-vertical">
            <button *ngFor="let section of nonPageBreakSections()"
                    (click)="addElementTypeToSection(elementType, section)"
                    type="button" class="btn btn-outline-primary btn-sm">
              {{ getSectionDisplayName(section) }}
            </button>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  </div>

  <div class="col-xl-8 col-9 pb-4 pt-3 document-wrapper">
    <h2 class="mb-4">{{ documentTemplate.name }}</h2>

    <div *ngFor="let section of documentTemplate.sections; let sectionIdx = index"
         class="card mb-4">
      <div class="card-header text-white font-weight-bold bg-secondary">
        <!-- Name -->
        <span *ngIf="!section.editingName">
          {{ getSectionDisplayName(section) }}
        </span>
        <input *ngIf="section.editingName" [(ngModel)]="section.name" (ngModelChange)="unsavedChanges.emit()"
               class="form-control w-50 d-inline-block">

        <!-- Control -->
        <div class="dropdown float-right section-button-margin"
             *ngIf="!sectionInEditMode(section)">
          <button class="btn btn-secondary btn-sm dropdown-toggle" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Options
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item"
               *ngIf="section.section_type === DocumentSectionType.custom"
               (click)="section.editingName = true;">
              Rename
            </a>
            <a class="dropdown-item"
               *ngIf="sectionIdx > 0"
               (click)="moveSectionToTop(sectionIdx)">
              <span>&uarr;&uarr;</span> Move to top
            </a>
            <a class="dropdown-item"
               *ngIf="sectionIdx > 0"
               (click)="moveSectionUp(sectionIdx)">
              &uarr; Move up
            </a>
            <a class="dropdown-item"
               *ngIf="sectionIdx < (documentTemplate.sections.length - 1)"
               (click)="moveSectionDown(sectionIdx)">
              &darr; Move down
            </a>
            <a class="dropdown-item"
               *ngIf="sectionIdx < (documentTemplate.sections.length - 1)"
               (click)="moveSectionToBottom(sectionIdx)">
              &darr;&darr; Move to bottom
            </a>
            <div class="dropdown-divider"
                 *ngIf="!ClimberInfoDocumentSectionTypes.includes(section.section_type)"></div>
            <a class="dropdown-item text-danger"
               *ngIf="!ClimberInfoDocumentSectionTypes.includes(section.section_type)"
               (click)="removeSection(sectionIdx)">
              Remove
            </a>
          </div>
        </div>
        <button class="btn btn-primary float-right"
                *ngIf="section.editingName"
                (click)="section.editingName = false;">
          Save Name
        </button>
      </div>

      <div class="card-body" *ngIf="section.section_type !== DocumentSectionType.pageBreak">
        <div *ngFor="let thisElement of section.elements; let elementIdx = index">
          <app-document-template-element
            [element]="section.elements[elementIdx]"
            [canMoveUp]="elementIdx > 0"
            [canMoveDown]="elementIdx < (section.elements.length - 1)"
            [canRemove]="canRemoveElement(thisElement, section)"
            [orgConfig]="orgConfig"
            (moveUp)="moveElementUp(elementIdx, section)"
            (moveDown)="moveElementDown(elementIdx, section)"
            (remove)="removeElement(elementIdx, section)"
            (unsavedChanges)="unsavedChanges.emit()">
          </app-document-template-element>

          <p *ngIf="getErrorForElement(sectionIdx, elementIdx)" class="text-danger">
            <span class="font-weight-bold">Error:</span> {{ getErrorForElement(sectionIdx, elementIdx) }}
          </p>
        </div>
      </div>
    </div>

    <button class="btn btn-success mb-4" (click)="addSection()">Add Section</button>
    <button class="btn btn-success mb-4 ml-2" (click)="addPageBreak()">Add Page Break</button>
  </div>

</div>
